import { supportedQuoteYears } from '@zorro/shared/databases';
import { formatDateISO, getFirstDayOfYear } from '@zorro/shared/formatters';

import { isDefined } from './isNullOrUndefined';

export type PriorYearPricingInput = {
  startOfCoverage: Date | string | null | undefined;
  quotingYear: number;
};

export const getIsJanuaryFirstCoverage = ({
  startOfCoverage,
  quotingYear,
}: PriorYearPricingInput): boolean =>
  isDefined(startOfCoverage) &&
  formatDateISO(startOfCoverage) ===
    formatDateISO(getFirstDayOfYear(quotingYear));

export const getIsPreviousYearSupported = (quotingYear: number): boolean =>
  supportedQuoteYears.includes(quotingYear - 1);

export const getIsPriorYearLcspAvailable = (
  input: PriorYearPricingInput
): boolean =>
  getIsJanuaryFirstCoverage(input) &&
  getIsPreviousYearSupported(input.quotingYear);
